class BasePageTransition{
	constructor() {
		if (pageTransitionEnabled) {
			$("body").imagesLoaded({
				background: true
			}).always(function () {
				pageTransition.enter(function () {
					$(window).trigger('transitionDone');
				});
			});
		} else {
			$(window).trigger('transitionDone');
		}
	}
}

